import React, { FC, useEffect, useContext, MouseEventHandler } from 'react';
import cx from 'classnames';
import ReactModal from 'react-modal';

import { LocaleContext } from '@/contexts/locale-context';

import { getStyles } from './styles.css';

let modalAppIsSetted = false;

/**
 * TYPINGS
 */
type ModalProps = ChildrenProps & {
	isOpen: boolean;
	onClose: MouseEventHandler;
	className?: string;
	modalId?: string;
};

/**
 * COMPONENT
 */
export const Modal: FC<ModalProps> = ({
	isOpen,
	onClose,
	className,
	modalId = '#__next',
	children,
}) => {
	const { __t } = useContext(LocaleContext);

	// Binds modal to the appElement for accessibility
	useEffect(() => {
		if (!modalAppIsSetted) {
			modalAppIsSetted = true;
			if (modalId !== '') ReactModal.setAppElement(modalId);
		}
	}, []);

	return (
		<ReactModal
			isOpen={isOpen}
			onRequestClose={onClose}
			className="supt-modal__wrapper"
			overlayClassName={cx(getStyles(), 'supt-modal', className)}
		>
			<div className="supt-modal__inner">
				<button onClick={onClose} className="supt-modal__close">
					{__t('modal-close', 'Close')}
				</button>

				<div className="supt-modal__content">{children}</div>
			</div>
		</ReactModal>
	);
};

export default Modal;
